export default "__VITE_ASSET__ClhM63rn__"